/** Canada Job Grant — federal cost-sharing for employee training (provincial delivery). */
export const CANADA_JOB_GRANT_TASKS = [
  {
    id: 1,
    name: "Provincial stream & eligibility",
    completed: false,
    subtasks: [
      { id: "1-1", name: "Identify provincial WDA delivery (ON, BC, AB, etc.)", completed: false },
      { id: "1-2", name: "Confirm employer size and training eligibility rules", completed: false },
      { id: "1-3", name: "Select accredited training provider and course", completed: false },
    ],
  },
  {
    id: 2,
    name: "Application (pre-approval)",
    completed: false,
    subtasks: [
      { id: "2-1", name: "Submit CJG application before training start date", completed: false },
      { id: "2-2", name: "Receive approval letter with funding amount", completed: false },
    ],
  },
  {
    id: 3,
    name: "Training & reimbursement",
    completed: false,
    subtasks: [
      { id: "3-1", name: "Complete training and collect completion certificates", completed: false },
      { id: "3-2", name: "Submit reimbursement claim with invoices and payroll", completed: false },
      { id: "3-3", name: "Confirm grant payment to employer", completed: false },
    ],
  },
];
